import { select, put } from "redux-saga/effects";

import { getCheckoutSchoolID } from "state/school_money/selectors";
import { clearBasketItems, fetchAll } from "state/school_money/actions";

/**
 * When we have completed a transaction, clear out all the
 *   basket items for that school and do a full data refresh.
 */
export default function* completeCheckoutSaga() {

  const schoolID = yield select(getCheckoutSchoolID);

  yield put(clearBasketItems(schoolID));
  yield put(fetchAll(true, true, true, true, true, true));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/completeCheckoutSaga.js